import './chat-component.scss';
import { ChatEntry } from '../../app/types';
import { insertSuits } from '../../utils/shark-helper';
import { outputActions } from '../../slices/outputSlice';
import { tableActions } from '../../slices/tableSlice';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { useTranslation } from 'react-i18next';
import React, { FunctionComponent, useEffect, useRef, useState } from 'react';
import moment from 'moment';

export const ChatComponent: FunctionComponent = () => {
    const { t } = useTranslation();
    const chatContainer = useRef<HTMLDivElement>(null);
    const [message, setMessage] = useState('');
    const [isDirectorMessage, setIsDirectorMessage] = useState(false);
    const [lastChatEntry, setLastChatEntry] = useState<ChatEntry | undefined>(undefined);
    const { chat, showChatSendForm } = useAppSelector((state) => state.table);
    const { user } = useAppSelector((state) => state.app);
    const { output_setChatEntry } = outputActions;
    const { table_clearChat } = tableActions;
    const dispatch = useAppDispatch();

    useEffect(() => {
        const _lastCHatEntry = chat[chat.length - 1];
        if (_lastCHatEntry !== lastChatEntry) {
            setLastChatEntry(_lastCHatEntry);
            if (chatContainer.current) {
                chatContainer.current.scrollTop = chatContainer.current.scrollHeight;
            }
        }
        // setTimeout(() => {
        //     props.clearSystemChat();
        // }, 30000);
    }, [chat]);

    const sendMessage = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        if (message) {
            const chatEntry: ChatEntry = {
                sender: user || 'unknown',
                timestamp: moment.utc().format(),
                message,
            };
            dispatch(output_setChatEntry({ ...chatEntry, isDirectorMessage }));
            setMessage('');
            setIsDirectorMessage(false);
        }
    };

    return (
        <section className={`ChatComponent`}>
            <div className="chat" ref={chatContainer}>
                {chat.map((chatEntry, index) => {
                    return (
                        !!chatEntry && (
                            <div
                                key={`${chatEntry.sender}-${chatEntry.timestamp}-${index}`}
                                className={`chatEntry ${chatEntry.sender === user ? 'isMe' : ''}`}
                            >
                                <header>
                                    <div className="sender">{chatEntry.sender}</div>
                                    <div className="time">{moment(chatEntry.timestamp).format('HH:mm')}</div>
                                </header>
                                <div
                                    className="text"
                                    dangerouslySetInnerHTML={{ __html: insertSuits(chatEntry.message) }}
                                />
                            </div>
                        )
                    );
                })}
            </div>
            {showChatSendForm && (
                <form onSubmit={sendMessage} className="sendMessage">
                    <div className="input">
                        <input
                            type="text"
                            value={message}
                            onChange={(e) => setMessage(e.target.value)}
                            placeholder={t(`chat.${isDirectorMessage ? 'typeDirectorMessage' : 'typeMessage'}`)}
                        />
                    </div>
                    {message ? <button type="submit" /> : <button type="button" onClick={() => table_clearChat()} />}
                    {message ? (
                        <button
                            type="submit"
                            className={`toggleDirectorMessage`}
                            onClick={() => setIsDirectorMessage(!isDirectorMessage)}
                        />
                    ) : (
                        <button
                            type="button"
                            className={`toggleDirectorMessage ${isDirectorMessage && 'isDirectorMessage'}`}
                            onClick={() => setIsDirectorMessage(!isDirectorMessage)}
                        />
                    )}
                </form>
            )}
        </section>
    );
};
